/* APLB — comparateur avant / apres.
   La barre balaie du centre vers la droite, revient, marque une pause au
   centre, part vers la gauche, revient, et recommence. Au survol (ordinateur)
   ou au glisser (tactile) elle suit le pointeur, puis l'animation reprend. */
(function () {
  if (customElements.get('aplb-compare')) return;

  function ease(t) {
    return 0.5 - Math.cos(Math.PI * Math.min(1, Math.max(0, t))) / 2;
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  class AplbCompare extends HTMLElement {
    connectedCallback() {
      // Dawn deplace la diapositive dans le DOM au changement de variante :
      // l'element est alors deconnecte puis reconnecte, il doit repartir.
      this.dead = false;
      this.frame = this.querySelector('.aplb-compare__frame');
      if (!this.frame) return;
      if (this.bound) {
        this.refresh();
        return;
      }
      this.bound = true;

      this.startPos = this.num('start', 50);
      this.minPos = this.num('min', 12);
      this.maxPos = this.num('max', 88);
      this.speed = Math.max(0.2, this.num('speed', 2)) * 1000;
      this.pause = Math.max(0, this.num('pause', 1)) * 1000;
      this.followPointer = this.dataset.hover !== 'false';

      this.pos = this.startPos;
      this.time = 0;
      this.last = null;
      this.manual = false;
      this.visible = false;
      this.raf = null;
      this.back = null;

      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      this.onFrame = this.onFrame.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onDrag = this.onDrag.bind(this);

      this.setPos(this.startPos);

      if (this.followPointer && this.fine) {
        this.addEventListener('pointermove', this.onPointerMove);
        this.addEventListener('pointerleave', this.onPointerLeave);
      }
      this.addEventListener('pointerdown', this.onPointerDown);

      if ('IntersectionObserver' in window) {
        var self = this;
        this.io = new IntersectionObserver(
          function (entries) {
            self.visible = entries[0].isIntersecting;
            self.refresh();
          },
          { threshold: 0.2 }
        );
        this.io.observe(this);
      } else {
        this.visible = true;
        this.refresh();
      }
    }

    disconnectedCallback() {
      this.dead = true;
      if (this.io) this.io.disconnect();
      this.stop();
      window.removeEventListener('pointermove', this.onDrag);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
    }

    num(key, fallback) {
      var value = parseFloat(this.dataset[key]);
      return isNaN(value) ? fallback : value;
    }

    setPos(value) {
      this.pos = Math.min(100, Math.max(0, value));
      this.style.setProperty('--aplb-cmp-pos', this.pos + '%');
    }

    posAt(time) {
      var p = this.pause;
      var s = this.speed;
      var total = 2 * p + 4 * s;
      var t = time % total;

      if (t < p) return this.startPos;
      t -= p;
      if (t < s) return lerp(this.startPos, this.maxPos, ease(t / s));
      t -= s;
      if (t < s) return lerp(this.maxPos, this.startPos, ease(t / s));
      t -= s;
      if (t < p) return this.startPos;
      t -= p;
      if (t < s) return lerp(this.startPos, this.minPos, ease(t / s));
      t -= s;
      return lerp(this.minPos, this.startPos, ease(t / s));
    }

    refresh() {
      if (this.visible && !this.manual && !this.reduce) this.play();
      else this.stop();
    }

    play() {
      if (this.raf || this.dead || !this.isConnected) return;
      this.last = null;
      this.raf = window.requestAnimationFrame(this.onFrame);
    }

    stop() {
      if (!this.raf) return;
      window.cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    onFrame(now) {
      if (this.dead || !this.isConnected) {
        this.raf = null;
        return;
      }
      this.raf = window.requestAnimationFrame(this.onFrame);
      if (this.last === null) {
        this.last = now;
        return;
      }
      var dt = Math.min(64, now - this.last);
      this.last = now;

      // Retour en douceur vers la position de repos apres un survol.
      if (this.back) {
        this.back.t += dt;
        var k = Math.min(1, this.back.t / this.back.d);
        this.setPos(lerp(this.back.from, this.startPos, ease(k)));
        if (k >= 1) {
          this.back = null;
          this.time = 0;
        }
        return;
      }

      this.time += dt;
      this.setPos(this.posAt(this.time));
    }

    fromEvent(event) {
      var rect = this.frame.getBoundingClientRect();
      if (!rect.width) return null;
      return ((event.clientX - rect.left) / rect.width) * 100;
    }

    takeOver() {
      this.manual = true;
      this.back = null;
      this.stop();
    }

    release() {
      if (!this.manual) return;
      this.manual = false;
      if (this.reduce) return;
      this.back = { from: this.pos, t: 0, d: 420 };
      this.refresh();
    }

    onPointerMove(event) {
      if (event.pointerType === 'touch') return;
      var value = this.fromEvent(event);
      if (value === null) return;
      this.takeOver();
      this.setPos(value);
    }

    onPointerLeave() {
      this.release();
    }

    onPointerDown(event) {
      // Au doigt on ne prend pas la main : le balayage horizontal doit rester
      // celui de la galerie produit, qui passe d'une photo a l'autre.
      if (event.pointerType === 'touch') return;
      var value = this.fromEvent(event);
      if (value === null) return;
      this.takeOver();
      this.setPos(value);
      this.dragId = event.pointerId;
      window.addEventListener('pointermove', this.onDrag, { passive: true });
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);
    }

    onDrag(event) {
      if (event.pointerId !== this.dragId) return;
      var value = this.fromEvent(event);
      if (value !== null) this.setPos(value);
    }

    onPointerUp() {
      window.removeEventListener('pointermove', this.onDrag);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
      this.release();
    }
  }

  customElements.define('aplb-compare', AplbCompare);
})();
